module.exports = "https://cdn2-fs.clearscore.com/flux/images/dd50c06cce07688d07d3dcbd720436b2.jpg";